const INPUT_SELECTOR = '.t5-input-chargeover-customer';

const ChargeOverCustomerInput = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        $scope.find(INPUT_SELECTOR).each(function () {
            const $input = $(this);
            const options = {
                ajax: {
                    url: $input.data('source'),
                    dataType: 'json',
                    delay: 300,
                    data: ({ term }) => ({ query: term }),
                },
                allowClear: true,
                minimumInputLength: 2,
                placeholder: $input.attr('placeholder'),
                width: '100%',
            };

            // https://select2.org/troubleshooting/common-problems#select2-does-not-function-properly-when-i-use-it-inside-a-bootst
            const $modal = $input.closest('.modal');

            if ($modal.length) {
                options.dropdownParent = $modal.find('.modal-body');
            }

            $input.select2(options);
        });
    },
};

export default ChargeOverCustomerInput;
